/** Backend-aligned domain values shared by API DTOs, routing, and UI. */

export const UserType = {
  Developer: "DEVELOPER",
  Employee: "EMPLOYEE",
  Financier: "FINANCIER",
  Service: "SERVICE",
} as const;

export type UserTypeValue = (typeof UserType)[keyof typeof UserType];

export const OrganizationType = {
  Platform: "PLATFORM",
  Merchant: "MERCHANT",
  Financier: "FINANCIER",
} as const;

export type OrganizationTypeValue = (typeof OrganizationType)[keyof typeof OrganizationType];

export const UserRole = {
  User: "USER",
  Superuser: "SUPERUSER",
  Admin: "ADMIN",
} as const;

export type UserRoleValue = (typeof UserRole)[keyof typeof UserRole];
